<template>
    <transition appear name="fade-msg" mode="out-in">
        <p :key="message" class="gi-app-loading-message">
            {{ message }}
        </p>
    </transition>
</template>

<script>
export function humanizeRouteName(name) {
    return name.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
}

export default {
    name: 'AppLoadingMessage',
    computed: {
        message() {
            const auth = this.Auth();

            if (!auth.has_user) {
                return this.$t('platform_load_message_verifying_session');
            }

            if (!auth.is_initialised) {
                return this.$t('platform_load_message_loading_account');
            }

            if (!auth.has_branding) {
                return this.$t('platform_load_message_loading_workspace');
            }

            const page = this.$route?.meta?.heading || (this.$route?.name && humanizeRouteName(this.$route.name));

            if (page) {
                return this.$t('platform_load_message_loading_page', { page });
            }

            return this.$t('platform_load_message_preparing_dashboard');
        }
    },
    watch: {
        message: {
            immediate: true,
            handler() {
                this.$emit('message-changed');
            }
        }
    }
};
</script>

<style scoped>
.gi-app-loading-message {
    margin: 1rem 0 0 0;
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.48);
    text-align: center;
    min-height: 1.25rem;
}

.fade-msg-enter-active,
.fade-msg-leave-active {
    transition: opacity 0.4s ease;
}
.fade-msg-enter,
.fade-msg-leave-to {
    opacity: 0;
}
</style>
